<div class="airo-wrapper">
  <mat-card class="airo-card">
    <!-- Header -->
    <div class="airo-header">
      <button mat-icon-button aria-label="Ask Airo" class="airo-ico-action">
        <img src="/assets/Icons/airoIcon.png" height="24px" />
      </button>
      <span class="fw-bold">Trend Signals</span>
    </div>

    <!-- Textarea + Button Row -->
    <div class="d-flex gap-2">
      <mat-form-field appearance="outline" class="query-field">
        <textarea
          matInput
          [(ngModel)]="query"
          placeholder='Describe what you&apos;re looking for... e.g. "Identify emerging AI opportunities in the healthcare sector for Q2 2025"'
          rows="3"
          (keydown.enter)="$event.shiftKey ? null : onAskAiro()"
        ></textarea>
      </mat-form-field>

      <button
        mat-flat-button
        color="primary"
        class="align-self-end mb-4 gap-3"
        [disabled]="isLoading"
        (click)="onAskAiro()"
      >
        Ask Airo
      </button>
    </div>

    <!-- Loader -->
    <div *ngIf="isLoading" class="loader-box d-flex align-items-center">
      <mat-spinner diameter="32"></mat-spinner>
      <p>Fetching results...</p>
    </div>

    <!-- Recent Queries Accordion -->
    <mat-accordion class="recent-accordion">
      <mat-expansion-panel [expanded]="false" hideToggle #recentPanel>
        <mat-expansion-panel-header>
          <mat-panel-title class="d-flex align-items-center gap-2">
            <mat-icon class="clock-icon">schedule</mat-icon>
            <span>Recent Queries</span>
            <span class="query-count-badge">{{ recentQueries.length }}</span>
            <span class="spacer"></span>
            <mat-icon class="chevron-icon">expand_more</mat-icon>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div *ngIf="recentQueries.length === 0" class="no-queries">
          No recent queries yet.
        </div>
        <ul class="p-0" *ngIf="recentQueries.length > 0">
          <li
            *ngFor="let q of recentQueries"
            (click)="loadQuery(q)"
            class="recent-item d-flex align-items-center px-4 py-2"
          >
            <span class="query-text">{{ q.query }}</span>
            <span class="query-time">
              {{ q.created_on | appFormat: "date_with_time" }}
            </span>
          </li>
        </ul>
      </mat-expansion-panel>
    </mat-accordion>

    <!-- Signal Analysis Section -->
    <div
      *ngIf="(summary || links.length) && !isLoading"
      class="signal-analysis-card"
    >
      <!-- Section Header -->
      <div class="signal-analysis-header">
        <mat-icon class="analysis-icon">bar_chart</mat-icon>
        <span class="analysis-title">Signal Analysis</span>
      </div>

      <!-- Airo Badge + Timestamp -->
      <div class="airo-meta-row">
        <button mat-icon-button aria-label="Ask Airo" class="airo-ico-action">
          <img src="/assets/Icons/airoIcon.png" height="24px" />
        </button>
        <span class="generated-at"
          >Generated at {{ generatedAt | appFormat: "date_with_time" }}</span
        >
      </div>

      <!-- Report Content Box -->
      <div class="report-box">
        <markdown class="report-content">{{ summary }}</markdown>
        <div *ngIf="links.length" class="links-box">
          <h4>Sources</h4>

          <div class="links-grid">
            <div
              class="link-item"
              *ngFor="let link of links; let i = index"
              (click)="openUrl(link.url)"
            >
              <span class="citation">{{ i + 1 }}</span>
              <span class="link-text">{{ link.name }}</span>
              <span class="link-icon">
                <mat-icon>open_in_new</mat-icon>
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="action-buttons">
        <button mat-flat-button color="primary" (click)="exportToPDF()">
          Export to PDF
        </button>
        <button
          mat-flat-button
          color="primary"
          class="bg-primary text-white"
          (click)="create()"
        >
          {{
            zone === "okr_convergence" ? "Add Objective" : "Create Hackathon"
          }}
        </button>
        <button mat-button color="primary" (click)="clearResults()">
          Clear
        </button>
      </div>
    </div>
  </mat-card>
</div>
